import { useForm } from 'react-hook-form';
import { IJobDetailsForm } from '../Types';
import { zodResolver } from '@hookform/resolvers/zod';
import { jobDetailsSchema } from '../schema';
import { IDraftJobPostEntity } from '~/domain/PermanentJobs';
import { JobDetailsFormMapper } from '../mappers/JobDetailsFormMapper';

interface IJobDetailsFormProps {
  initialValues?: IDraftJobPostEntity;
}

export const useJobDetailsForm = ({ initialValues }: IJobDetailsFormProps) => {
  return useForm<IJobDetailsForm>({
    mode: 'onSubmit', // Validate only on submit
    resolver: zodResolver(jobDetailsSchema),
    defaultValues: JobDetailsFormMapper.fromDraft(initialValues),
  });
};
